export const TCell = ({ children }) => (
  <section className='data-table_cell'>
    {children}
  </section>
);
